import script from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreAchievement.vue?vue&type=script&setup=true&lang=js"

import "./ScoreAchievement.vue?vue&type=style&index=0&id=4e1e1827&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1e1827"]])

export default __exports__